import { Environment } from '../constants/environments'
import { WebAppUrls } from '../constants/web-app-urls'

export function getWebAppUrl(environment?: Environment) {
  const env = environment ?? Environment.Production
  return WebAppUrls[env]
}
